export default "__VITE_ASSET__DRqPWIGT__"